<template>
  <div class="news">
    <div v-for="item in news_data" :key="item.index" v-on:click="showPop(item)" class="new_main">
      <div class="img">
        <img :src=" 'http://moderncap.pengjisoft.com/'+ item.img" alt>
      </div>
      <div class="text">
        <h2 class="overflow_line1">{{ item.title }}</h2>
        <p class="overflow_line2">{{ item.content_pure }}</p>
      </div>
    </div>
    <div class="more" v-if="new_page" v-on:click="getMore()">点击加载更多</div>
    <news-pop v-if="isPop" :pop_data="pop_data" v-on:hidePop="hidePop"/>
  </div>
</template>

<script>
import NewsPop from "../components/news_pop";
import axios from "axios";
export default {
  components: {
    NewsPop
  },
  data() {
    return {
      isPop: false,
      news_data: [],
      new_page: "",
      pop_data: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData: function(url) {
      var getUrl = url
        ? url
        : "http://moderncap.pengjisoft.com/api/news/get_all?page=1";
      axios.get(getUrl).then(res => {
        let data = res.data;
        let value = data.data;
        value.map(item => {
          this.news_data.push(item);
        });
        this.new_page = data.next_page_url;
      });
    },
    getMore: function() {
      this.getData(new_page);
    },
    showPop: function(item) {
      this.pop_data = item;
      this.isPop = true;
    },
    hidePop: function() {
      this.isPop = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/global.less";
.news {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 40px;
  max-height: 82%;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 1px;
    background: @bordercolor;
  }
  @media screen and (max-width: 768px) {
    max-height: 90%;
    margin-top: 0px;
    padding-bottom: 60px;
  }
  .new_main {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .img {
      width: 133px;
      height: 133px;
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 80px;
      }
      border-radius: 50%;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .text {
      margin-left: 20px;
      flex: 1;
      h2 {
        font-size: 18px;
        line-height: 40px;
        font-weight: 400;
        @media screen and (max-width: 768px) {
          font-size: 16px;
          line-height: 32px;
        }
      }
    }
    p {
      font-size: 16px;
      line-height: 30px;
      @media screen and (max-width: 768px) {
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
  .more {
    width: 100%;
    text-align: center;
    padding-bottom: 30px;
    font-size: 18px;
  }
}
@-moz-documentc .overflow_line2 {
  position: relative;
  font-size: 16px;
  line-height: 30px;
  max-height: 60px;
  overflow: hidden;
  &:after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 0;
    padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(right, transparent, #fff 55%);
    background: -moz-linear-gradient(right, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);
  }
}
</style>

